import * as React from "react";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";

import { Dimension, OutputTag } from "../../../types/models";
import { ThunkDispatch } from "../../../types/redux";
import { RootState } from "../../../store/reducer";

import AppViewTemplate from "../../templates/AppView";
import { MaxBound } from "../../atoms/Layout";
import ConfigTabs from "src/components/organisms/ConfigTabs";
import DimensionsTab from "../../organisms/ConfigTabs/DimensionsTab";
import AttributesTab from "../../organisms/ConfigTabs/AttributesTab";
import OutputsTab from "../../organisms/ConfigTabs/OutputsTab";
import { ClientMap } from "src/store/modules/client";

interface IProps extends RouteComponentProps<any> {
  dimensions: Dimension[];
  dispatch: ThunkDispatch;
  outputTags: OutputTag[];
  clients: ClientMap;
}

interface IState {
  clientId: number;
  selectedTab: string;
}

class ConfigView extends React.Component<IProps, IState> {
  public state: IState = {
    // isLoading: true,
    clientId: this.props.match.params.client,
    selectedTab: this.props.match.params.filter || "dimensions",
  };

  public componentDidMount() {
    const isClientTaxonomyEnabled =
      this.props.clients[this.props.match.params.client]
        .IsClientTaxonomyEnabled;
    if (!isClientTaxonomyEnabled) {
      this.props.history.push(`/clients/${this.props.match.params.client}`);
      return;
    }
  }

  public componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>
  ) {
    // Update selectedTab if route filter param changes
    if (prevProps.match.params.filter !== this.props.match.params.filter) {
      this.setState({
        selectedTab: this.props.match.params.filter || "dimensions",
      });
    }
  }

  public render() {
    const { dispatch } = this.props;
    const { selectedTab, clientId } = this.state;

    const getTabTitle = () => {
      switch (selectedTab) {
        case "dimensions":
          return "Dimensions Master";
        case "attributes":
          return "Attributes Master";
        case "outputs":
          return "Output Tags";
        default:
          return "Client Configuration";
      }
    };

    return (
      <React.Fragment>
        <AppViewTemplate
          title={getTabTitle()}
          tabs={<ConfigTabs selectedTab={selectedTab} dispatch={dispatch} />}
        >
          <MaxBound mt={3} minHeight="calc(100vh - 135px)" overflowY="auto">
          
              <>
                {selectedTab === "dimensions" && (
                  <DimensionsTab clientId={clientId} dispatch={dispatch} />
                )}
                {selectedTab === "attributes" && (
                  <AttributesTab clientId={clientId} dispatch={dispatch} />
                )}
                {selectedTab === "outputs" && (
                  <OutputsTab clientId={clientId} />
                )}
              </>
        
          </MaxBound>
        </AppViewTemplate>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  outputs: state.outputs,
  dimensions: state.dimensions,
  calculationBlocks: state.calculationBlocks,
  clients: state.clients,
});

export default connect(mapStateToProps)(withRouter(ConfigView));
